import { useRouter } from 'next/router'
import { ParsedUrlQueryInput } from 'node:querystring'

type RedirectOptions = {
  query?: ParsedUrlQueryInput
  keepSlug?: boolean
  keepQuery?: boolean
  routerOptions?: any
}

export const useRedirect = () => {
  const router = useRouter()
  const slug = router.query.subpath?.toString()

  const redirect = (
    pathname: string,
    options: RedirectOptions = { keepSlug: false, keepQuery: true }
  ) => {
    const keepSlug = options.keepSlug ?? false
    const keepQuery = options.keepQuery ?? true
    const routerQuery = { ...router.query }
    if (routerQuery) {
      delete routerQuery.subpath
      delete routerQuery.type
    }
    router.push(
      {
        pathname: keepSlug ? `${slug ? `/${slug}` : ''}${pathname}` : pathname,
        query: keepQuery ? { ...routerQuery, ...options.query } : { ...options.query }
      },
      undefined,
      options.routerOptions
    )
  }

  return redirect
}

/**
 * Go to the thankyou page like cms-template-default: drop the product-page
 * params (`vb`, `subpath`) and tag the URL with the purchased order id (`afs`).
 */
export const useRedirectThankyou = () => {
  const router = useRouter()
  const redirect = useRedirect()

  return (orderId?: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { vb, subpath, type, afs, ...query } = router.query
    redirect('/thankyou', {
      query: { ...query, ...(orderId ? { afs: orderId } : {}) },
      keepQuery: false
    })
  }
}
